module.exports = __webpack_public_path__ + "img/use-gb-whatsapp.b3f25ea5.webp";